import { jsx as C } from "react/jsx-runtime";
const M = ({ className: o, width: t = "31", height: l = "31" }) => /* @__PURE__ */ C(
  "svg",
  {
    className: o,
    width: t,
    height: l,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 31",
    fill: "none",
    children: /* @__PURE__ */ C(
      "path",
      {
        d: "M4.06364 14.0319C4.44629 9.6549 7.39724 6.01412 11.4008 4.62524C11.1153 5.09858 10.857 5.62247 10.6261 6.18335C9.76786 8.26756 9.22402 11.0159 9.12757 14.0319H4.06364ZM15.0006 2.08398C7.86694 2.08398 2.08398 7.86698 2.08398 15.0007C2.08398 22.1343 7.86694 27.9173 15.0006 27.9173C22.1343 27.9173 27.9173 22.1343 27.9173 15.0007C27.9173 7.86697 22.1343 2.08398 15.0006 2.08398ZM15.0006 4.02148C15.3382 4.02148 15.7504 4.18356 16.2215 4.66742C16.6955 5.15434 17.167 5.90931 17.5836 6.92105C18.3302 8.73413 18.8391 11.2224 18.9351 14.0319H11.0661C11.1621 11.2224 11.6711 8.73413 12.4176 6.92105C12.8342 5.90931 13.3057 5.15434 13.7798 4.66742C14.2508 4.18356 14.663 4.02148 15.0006 4.02148ZM20.8737 14.0319C20.7772 11.0159 20.2334 8.26756 19.3752 6.18335C19.1442 5.62247 18.886 5.09858 18.6004 4.62524C22.604 6.01412 25.555 9.6549 25.9376 14.0319H20.8737ZM18.9351 15.9694C18.8391 18.7789 18.3302 21.2672 17.5836 23.0803C17.167 24.092 16.6955 24.847 16.2215 25.3339C15.7504 25.8177 15.3382 25.9798 15.0006 25.9798C14.663 25.9798 14.2508 25.8177 13.7798 25.3339C13.3057 24.847 12.8342 24.092 12.4176 23.0803C11.6711 21.2672 11.1621 18.7789 11.0661 15.9694H18.9351ZM18.6004 25.3761C18.886 24.9027 19.1442 24.3788 19.3752 23.818C20.2334 21.7337 20.7772 18.9854 20.8737 15.9694H25.9376C25.555 20.3464 22.604 23.9872 18.6004 25.3761ZM11.4008 25.3761C7.39724 23.9872 4.44629 20.3464 4.06364 15.9694H9.12757C9.22402 18.9854 9.76786 21.7337 10.6261 23.818C10.857 24.3788 11.1153 24.9027 11.4008 25.3761Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  M as default
};
